<template>
    <div class="BoxShow Center">
        <div class="boxType1" v-if="thatData.type<2">
          <img :src="thatData.url" class="wid100" alt="">
          <div class="main">
<!--              <div class="share_icon">-->
<!--                <img src="../assets/btn/share_icon.png" @click="shares" class="wid100" alt="">-->
<!--              </div>-->
              <div class="href">
               <a href="https://open.shrbank.com/u/mQOhD"  target="_blank" v-if="thatData.id < 3 "> <img src="../assets/btn/href.png" class="wid100" alt=""></a>
               <a href="https://open.shrbank.com/hrbank/carleasing/benefits/index.html?channelId=yxin&fromId=hrcs000014" target="_blank" v-else> <img src="../assets/btn/href.png" class="wid100" alt=""></a>
              </div>
              <div class="close"  @click="handleClose">
                <img src="../assets/btn/close.png" class="wid100" alt="">
              </div>
          </div>

        </div>

      <div class="boxType2" v-else>
          <img :src="thatData.url" class="wid100" alt="">
          <div class="main">
<!--              <div class="share_icon">-->
<!--                <img src="../assets/btn/share_icon.png" @click="shares" class="wid100" alt="">-->
<!--              </div>-->

<!--            <div class="href">-->
<!--                <img src="../assets/btn/share.png" class="wid100" alt="">-->
<!--            </div>-->
              <div class="close"  @click="handleClose">
                <img src="../assets/btn/close.png" class="wid100" alt="">
              </div>
          </div>
        </div>
      <div class="mask" v-if="thatData.type<2">
        <div class="slg1 End">
          <img src="../assets/card/2/6.png" class="wid100" alt="">
        </div>
        <div class="slg2 Start">
          <img src="../assets/card/2/5.png" class="wid100" alt="">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "BoxShow",
  props: {
    // 奖品等级：1-一等奖, 2-二等奖, 3-三等奖, 0-未中奖
    BoxData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      thatData: {},
    }
  },
  watch: {
    BoxData: {
      handler(val) {
        this.thatData = val
      },
      immediate: true  // ✅ 组件创建时立即执行
    }
  },
  created() {

  },

  methods: {
    handleClose() {
      this.$emit('close')
    },
    shares() {
      this.$emit('shares')
    },
  }
}
</script>

<style scoped>
  .BoxShow{width: 100%; height: 100%;  position: fixed; z-index: 20; top:0; left: 0; background: rgba(0,0,0,0.8); vertical-align: middle}

  .BoxShow .boxType1{width: 85%; margin-top: -10%; position: relative; text-align: center;}
  .BoxShow .boxType1 .main{position: absolute; width: 100%; height: 100%;top:0;}
  .BoxShow .boxType1 .share_icon{position: absolute; width: 12%;top:10%; right: 12%;}
  .BoxShow .boxType1 .href{position: absolute; width: 50%;bottom:-3%; left: 25%}
  .BoxShow .boxType1 .close{position: absolute; width: 12%;bottom:-9%; left: 44%; }
  .BoxShow .boxType2{width: 90%; position: relative;}
  .BoxShow .boxType2 .href{position: absolute; width: 50%;bottom:-3%; left: 25%}
  .BoxShow .boxType2 .main{position: absolute; width: 100%; height: 100%;top:0;}
  .BoxShow .boxType2 .share_icon{position: absolute; width: 12%;top:-13%; right: 5%;}
  .BoxShow .boxType2 .close{position: absolute; width: 12%;bottom:-9%; left: 44%; }
  .mask{width: 100%; height: 100%; position: absolute; z-index: 2; background: url("../assets/card/2/7.jpg")center no-repeat; background-size: cover;
    animation: hideMask 1s 2s linear forwards;
    pointer-events: none;
  }
  .mask .slg1{width: 100%; height: 30%;}
  .mask .slg1 img{width: 75%;}
  .mask .slg2{width: 100%; height: 30%; margin-top: 10%;}
  .mask .slg2 img{width:45%;}
  @-webkit-keyframes hideMask {
      0%{opacity: 100}
      100%{opacity: 0;}
  }
</style>



// WEBPACK FOOTER //
// src/components/BoxShow.vue